import { object, string, number } from 'yup'
import { IBusquedaSubZone } from '../../interfaces/SubZone/SubZone'

export const busquedaInitialState: IBusquedaSubZone = {
  subZoneCode: '',
  subZoneName: ''
}

export const createInitialValue = {
  id: 0,
  activo: false
}

export const subZoneValidationSchema = object({
  subZoneCode: string()
    .trim()
    .required('El campo código de subzona es requerido.')
    .min(2, 'Debe ingresar a lo menos 2 caracteres')
    .max(50, 'Máximo 50 caracteres.'),
  subZoneName: string()
    .required('Debe ingresar un nombre para la subzona')
    .min(2, 'Debe ingresar al menos 2 carácteres')
    .max(50, 'Debe ingresar como máximo 50 carácteres')
    .matches(
      /^[A-Z0-9]+$/,
      'Nombre de subzona acepta solo mayusculas, sin espacios ni carácteres especiales.'
    ),
  subZoneDescription: string()
    .trim()
    .required('El campo descripción de subzona es requerido.')
    .min(1, 'Debe ingresar a lo menos 3 caracteres')
    .max(200, 'Máximo 200 caracteres.'),
  zoneId: number()
    .required('Debe seleccionar una zona')
    .min(1, 'Debe seleccionar una zona')
})
